import React from 'react';
import { Box, Typography } from '@mui/material';
import { NoDataIcon } from '../../icons';

const NoData = ({ titleNoData = 'Nothing to Report', bodyNoData = "Expecting data? Try adjusting your report filters or selecting a different date range." }) => {
  return (
    <Box
      sx={{
        textAlign: 'center',
        py: 6,
        px: 3,
        color: 'text.secondary',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
      }}
    >
      <Box className = 'nodatasvg-icon'>
        <NoDataIcon sx={{}} />
      </Box>
      <Typography variant="h6" component="h6" sx={{ fontWeight: 600, mt: 1 }}>
        {titleNoData}
      </Typography>
      <Typography variant="body2" sx={{ maxWidth: 360 }}>
        {bodyNoData}
      </Typography>
    </Box>
  );
};

export default NoData;

